import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import OutputMappings from '../../../shared/output-mappings';
import { INVESTIGATION_ID_OUTPUT_OPTION_VALUE } from '../../types';
type OutputDataProps = {
  canEdit: boolean;
  availableOutputs: string[];
};
const OutputData = t0 => {
  const $ = _c(16);
  const {
    canEdit,
    availableOutputs
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "aiDecisionNode.outputData"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("playbook-builder", t1);
  let t2;
  if ($[1] !== t) {
    t2 = t(_temp);
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== availableOutputs) {
    let t4;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = {
        value: INVESTIGATION_ID_OUTPUT_OPTION_VALUE,
        label: "investigation_id"
      };
      $[5] = t4;
    } else {
      t4 = $[5];
    }
    t3 = [...availableOutputs.map(_temp2), t4];
    $[3] = availableOutputs;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[6] !== t) {
    t4 = t(_temp3);
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t) {
    t5 = t(_temp4);
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== canEdit || $[11] !== t2 || $[12] !== t3 || $[13] !== t4 || $[14] !== t5) {
    t6 = <OutputMappings canEdit={canEdit} subtitle={t2} options={t3} outputLabel={t4} outputAddon="outputs." emptyMessage={t5} />;
    $[10] = canEdit;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
};
export default OutputData;
function _temp($) {
  return $.subtitle;
}
function _temp2(fieldKey) {
  return {
    value: fieldKey,
    label: fieldKey
  };
}
function _temp3($_0) {
  return $_0.outputLabel;
}
function _temp4($_1) {
  return $_1.noOutputs;
}